import type { Children } from '../../../types'

function SectionHeading({ children }: Children) {
  return (
    <div className="text-ion-color-primary ml-5 font-semibold">{children}</div>
  )
}

export { SectionHeading }
